import React from 'react';
import classNames from 'classnames';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

// Logos
import FIREFOX_LOGO from '../img/logo/firefox_logo.png';
import CHROME_LOGO from '../img/logo/chrome_logo.png';
import SAFARI_LOGO from '../img/logo/safari_logo.png';

import Logo from './Logo';

const AlertOutdatedBrowser = () => {
  const topBarClass = classNames({
    topbar: true
  }); // END topBarClass

  const browsers = [
    {
      img: FIREFOX_LOGO,
      alt: 'firefox logo',
      message: 'Versión 75 y posteriores',
      link: 'https://www.mozilla.org/es-MX/firefox/new/'
    },
    {
      img: CHROME_LOGO,
      alt: 'chrome logo',
      message: 'Versión 80 y posteriores',
      link: 'https://www.google.com/intl/es/chrome/'
    },
    {
      img: SAFARI_LOGO,
      alt: 'safari logo',
      message: 'Versión 11 y posteriores',
      link: 'https://support.apple.com/es_MX/downloads/safari'
    }
  ]; // END browsers

  return (
    <div className="alert_browser-outdated">
      <div className={topBarClass}>
        <div className="topbar__wrapper">
          <div className="topbar__left">
            <Logo />
          </div>
        </div>
      </div>

      <div className="row_logo">
        <ReportProblemOutlinedIcon fontSize="large" className="logo" />
      </div>

      <div className="row_title">Navegador sin soporte</div>

      <div className="row_message">
        <p>Para mejorar tu experiencia, actualiza tu navegador o prueba uno de los siguientes buscadores</p>
      </div>

      <div className="row_message">
        <p>Por cobrar esta optimizado para:</p>
      </div>

      <div className="row_logos">
        {browsers.map((b, i) => {
          return (
            <div key={i} className="column_logo">
              <img src={b.img} alt={b.alt} className="logo" />
              <a href={b.link} target="_blank" rel="noreferrer">
                {b.message}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AlertOutdatedBrowser;



// WEBPACK FOOTER //
// ./src/components/AlertOutdatedBrowser.js